<template>
<v-container fluid >
    <h1 class="d-flex justify-center textTitle--text font-weight-black">{{ $t('views.sales.screenTitle') }}</h1>
    <v-card elevation="11" class="ma-3 pa-3 primary">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('search')"
        single-line
        class="tertiary font-weight-black mx-8"
        hide-details
        outlined
      ></v-text-field>
    <v-row justify="center" align="center">
      <v-chip label class="pa-5 ma-3 quaterny text-h6" >
        <v-icon
        large
        color="red darken-4"
      >mdi-delete</v-icon>{{$t('views.sales.helpDelete')}}
      </v-chip>
      <v-chip label class="pa-5 ma-3  quaterny text-h6">
       <v-icon
        large
        color=" blue darken-4"
      >mdi-pencil</v-icon>{{$t('views.sales.helpModif')}}
      </v-chip>
      
      
    </v-row>
    <v-data-table
    :headers="headers"
    :items="sales"
    class="elevation-5 tertiary pa-3 ma-5 textTable--text font-weight-black text-h3"
    :search="search"
    
  >
  <template v-slot:[`item.fecha`]="{ item }">
    
           <span>{{new Date(item.fecha) | dateFormat('DD MMMM YYYY')}}</span>
         </template>
    
    
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon
        small
        class="mr-2"
        color=" blue darken-4"
        @click="editItem(item)"
      >mdi-pencil</v-icon>

      <v-icon
        small
        color="red darken-4"
        @click="deleteProduct(item)"
      >mdi-delete</v-icon>
      <v-dialog v-model="dialogDelete" max-width="500px" :retain-focus="false"> 
        <v-card class="pa-5 secondary">
          <v-card class="pa-5 primary" elevation="11">
            <v-card-text class="textTitle--text text-h6">{{ $t('views.sales.confirmDelete') }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error font-weight-black black--text" @click="closeDelete">{{ $t('cancel') }}</v-btn>
              <v-btn color="success font-weight-black black--text" @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-card>
        </v-dialog>


        <v-dialog v-model="dialogModif" max-width="80%" :retain-focus="false">
          <v-card class="pa-5 secondary">
          <v-card class="pa-5 primary" elevation="11">
            <v-card-title class="headline font-weight-black textTitle--text d-flex justify-center">{{ $t('views.sales.returnProd') }}</v-card-title>
            <v-simple-table
    fixed-header

  >
    <template v-slot:default>
      <thead>
        <tr>
            
          <th class="text-center quaterny primary--text font-weight-black text-subtitle-2">{{ $t('addproduct.prodName') }}</th>
          <th class="text-center quaterny primary--text font-weight-black text-subtitle-2">{{ $t('addproduct.prodCode') }}</th>
          <th class="text-center quaterny primary--text font-weight-black text-subtitle-2">{{ $t('addpreciocompramayor.pu') }}</th>
          <th class="text-center quaterny primary--text font-weight-black text-subtitle-2">{{ $t('qty') }}</th>
          <th class="text-center quaterny black--text font-weight-black text-h6">{{ $t('views.sales.returnProd') }}</th>
          <th class="text-center quaterny primary--text font-weight-black text-subtitle-2">{{ $t('confirm') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="prod in saleactive.products"
          :key="prod.id"
          class="tertiary font-weight-black text-center textTable--text"
        >
            
          <td>{{ prod.name }}</td>
          <td>{{ prod.codigo }}</td>
          <td>{{ prod.pu }}</td>
          <td>{{ prod.qty }}</td>
          <td>
            <v-row class="align-center justify-center"><v-icon class="mx-2" @click="minusQty()">mdi-minus</v-icon>
            <v-text-field min=0 :max="prod.qty" class="ma-1 pa-1 shrink" type="number" v-model.number="returnprod"></v-text-field>
            <v-icon class="mx-2" @click="masQty(prod)">mdi-plus</v-icon></v-row>
            </td>
        
        <td><v-icon color="success darken-4" large class="font-weight-black" @click="confirmQty(prod.id)">mdi-check-outline</v-icon></td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
            
          </v-card>
          </v-card>
        </v-dialog>
    </template>
    
  </v-data-table>
      
    </v-card>
    
    
</v-container>
</template>

<script>
          
export default {
    data () {
        return {
            search:"",
            dialogDelete:false,
            dialogModif:false,
            returnprod:0,

            
            saleactive:{},

        }

    },
    computed:{
      headers(){
        var headers= [
              { text: this.$t('headers.actions'), value: 'actions', sortable: false,class: 'quaterny primary--text font-weight-black text-subtitle-2' },
              {
                text: this.$t('date'),
                align: 'start',
                value: 'fecha',
                class: 'quaterny primary--text font-weight-black text-subtitle-2'
              },
              {
                text: this.$t('headers.client'),
                align: 'start',
                value: 'clientName',
                class: 'quaterny primary--text font-weight-black text-subtitle-2'

              },{
                text: this.$t('headers.dpi'),
                align: 'start',
                value: 'dpi',
                class: 'quaterny primary--text font-weight-black text-subtitle-2'

              },
              { text: this.$t('total'), value: 'total',class: 'quaterny primary--text font-weight-black text-subtitle-2'},
              
            ]
            return headers
      },
      sales(){
        return this.$store.state.sales
      }
    },
    methods:{
      masQty(prod){
         if(prod.qty>this.returnprod){
        this.returnprod+=1}
      },
      minusQty(){
        if(this.returnprod>0){
        this.returnprod-=1}
      },
     
        deleteItemConfirm () {
             var idsale=this.saleactive.id;
             var payload={}

             //restore the products to the inventory
          for(var i=0;i<this.saleactive.products.length;i++){
            payload={"id":this.saleactive.products[i].id,"qty":this.saleactive.products[i].qty}
            this.$store.dispatch('restoreProdInv',payload)
            
          }

          //modify the client total buys
          payload={"id":this.saleactive.clientId,"idsale":idsale,"total":this.saleactive.total}
            this.$store.dispatch('modifClientTotalBuy',payload)
            this.$store.dispatch('deleteSale',idsale)

        this.closeDelete()
      },
      closeDelete () {
        this.dialogDelete = false
        
      },
      editItem (item) {
        
        this.saleactive=item
        this.dialogModif=true
      },
      deleteProduct(item){
        this.dialogDelete = true
        this.saleactive=item
      },
      confirmQty(id){
        var payload={"prodid":id,"sale":this.saleactive,"returnQty":this.returnprod}
        this.$store.dispatch('updateQtySale',payload)
          
          
                this.dialogModif=false
                this.returnprod=0


      }

    }
}
</script>